import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

function GuideHeader({ currentStep }) {
  const { t } = useTranslation()

  return (
    <div className="card card-header section-container">
      <div className="progressbar-container">
        <ul className="progressbar-tab">
          {currentStep === 5 ? (
            <span
              style={{
                fontSize: '38px',
                fontWeight: '900',
                color: '#333',
              }}
            >
              {t('saving_changes')}
            </span>
          ) : (
            <>
              <li
                className={classNames('book-info-icon', {
                  active: currentStep === 1,
                  complete: currentStep > 1,
                })}
              >
                <strong>{t('book_info')}</strong>
              </li>
              <li
                className={classNames('book-author-icon', {
                  active: currentStep === 2,
                  complete: currentStep > 2,
                })}
              >
                <strong>{t('main_author')}</strong>
              </li>
              <li
                className={classNames('book-people-icon', {
                  active: currentStep === 3,
                  complete: currentStep > 3,
                })}
              >
                <strong>{t('add_people')}</strong>
              </li>
              <li
                className={classNames('book-story-icon', {
                  active: currentStep === 4,
                  complete: currentStep > 4,
                })}
              >
                <strong>{t('add_story_prompts')}</strong>
              </li>
            </>
          )}
        </ul>
      </div>
    </div>
  )
}

export default GuideHeader
